module.exports = __webpack_public_path__ + "static/media/jennifer.dc55fa6e.png";